import React, { useEffect, useRef } from 'react';
import { formatTime, formatUsername } from '../utils/formatters';

const MessageList = ({ messages, onScroll, forwardedRef }) => {
  const internalMessagesContainerRef = useRef(null);
  const messagesEndRef = useRef(null);
  
  const messagesContainerRef = forwardedRef || internalMessagesContainerRef;
  
  const userNearBottomRef = useRef(true);
  const initialScrolledRef = useRef(false);

  const scrollToBottom = (smooth = true) => {
    const el = messagesContainerRef.current;
    if (!el) return;
    el.scrollTo({ top: el.scrollHeight, behavior: smooth ? 'smooth' : 'auto' });
  };

  const handleMessagesScroll = () => {
    const el = messagesContainerRef.current;
    if (!el) return;
    
    const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
    userNearBottomRef.current = distanceFromBottom < 80;
    
    if (onScroll) {
      onScroll(el);
    }
  };

  useEffect(() => {
    if (!initialScrolledRef.current) {
      initialScrolledRef.current = true;
      scrollToBottom(false);
      return;
    }

    const last = messages[messages.length - 1];
    const lastIsOwn = Boolean(last?.is_own);

    if (userNearBottomRef.current || lastIsOwn) {
      scrollToBottom(true);
    }
  }, [messages]);

  const chatMessages = messages.filter((msg) => msg.type !== 'system');

  return (
    <div 
      className="messages-container" 
      ref={messagesContainerRef} 
      onScroll={handleMessagesScroll}
    >
      {chatMessages.length === 0 ? (
        <div className="no-messages-placeholder">
          <div className="no-messages-text">
            Пока нет сообщений. В чате вы можете задать вопросы по теме вебинара.
          </div>
        </div>
      ) : (
        <>
          {chatMessages.map((msg) => (
            <div
              key={msg.id}
              className={`message ${
                msg.type === 'message' 
                  ? msg.is_own ? 'own' : 'other'
                  : 'system'
              }`}
            >
              {msg.type === 'message' && (
                <div className="message-header">
                  <span className="message-username">
                    {formatUsername(msg.username)}
                  </span>
                  <span className="message-time">{formatTime(msg.timestamp)}</span>
                </div>
              )}
              <div className="message-content">{msg.text}</div>
            </div>
          ))}
        </>
      )}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
